export const medicalConditions = [
    {
        title: 'Neurology',
        values: [
            { title: 'Migraine Headache', value: false },
            { title: 'Cluster Headache', value: false },
            { title: 'Multiple sclerosis', value: false },
            { title: 'Myasthenia gravis', value: false },
            { title: 'Paraplegia/Quadriplegia', value: false },
            { title: 'Seizures/Epilepsy', value: false },
            { title: 'TIA (Transient Ischemic Attack)', value: false },
            { title: 'Stroke (Cerebrovascular Accident - CVA)', value: false },
            { title: "Parkinson's disease", value: false },
        ],
    },
    {
        title: 'Eyes/nose/ears/throat',
        values: [
            { title: 'Pink eye', value: false },
            { title: 'Stye', value: false },
            { title: 'Cataract', value: false },
            { title: 'Glaucoma', value: false },
            { title: 'Sinus infection', value: false },
            { title: 'Middle ear infection', value: false },
            { title: "Swimmer's ear (external ear infection)", value: false },
            { title: 'Strep throat', value: false },
            { title: 'Mononucleosis', value: false },
        ],
    },
    {
        title: 'Cardiovascular',
        values: [
            { title: 'High blood pressure', value: false },
            { title: 'High cholesterol', value: false },
            { title: 'Heart disease (Coronary Artery Disease - CAD)', value: false },
            { title: 'Artial fibrillation/flutter', value: false },
            { title: 'Supraventricular tachycardia (SVT)', value: false },
            { title: 'Ventricular tachycardia', value: false },
            {
                title: 'Heart bypass surgery (Coronary Artery Bypass Graft)',
                value: false,
            },
            { title: 'Congestive heart failure (CHF)', value: false },
            { title: 'Pacemaker', value: false },
            {
                title: 'AICD (Automated Implantable Cardioverter Defibrillator)',
                value: false,
            },
            { title: 'Peripheral vascular disease', value: false },
        ],
    },
    {
        title: 'Respiratory',
        values: [
            { title: 'Asthma', value: false },
            { title: 'Pnuemonia', value: false },
            { title: 'Bronchitis', value: false },
            { title: 'Bronchiectasis', value: false },
            { title: 'Tuberculosis', value: false },
        ],
    },
    {
        title: 'Psychiatric',
        values: [
            { title: 'Depression', value: false },
            { title: 'Bipolar disorder', value: false },
            { title: 'Schizophrenia', value: false },
            { title: 'Anxiety disorder', value: false },
        ],
    },
    {
        title: 'Travel-related',
        values: [
            { title: "Traveler's diarrhea", value: false },
            { title: 'Malaria', value: false },
            { title: 'Dengue', value: false },
            { title: 'Zika', value: false },
            { title: 'Motion sickness', value: false },
            { title: 'Altitude illness', value: false },
        ],
    },
    {
        title: 'Gastrointestinal (GI)',
        values: [
            { title: 'Gastritis', value: false },
            { title: 'Stomach ulcer', value: false },
            { title: 'Irritable bowel syndrome', value: false },
            {
                title:
                    "Inflammatory bowel disease (Crohn's disease, Ulcerative Colitis)",
                value: false,
            },
            { title: 'Diverticulosis/Diverticulitis', value: false },
        ],
    },
    {
        title: 'Genitourinary (GU)',
        values: [
            { title: 'Bladder infection', value: false },
            { title: 'Kidney stones', value: false },
            { title: 'Chronic kidney disease', value: false },
            { title: 'Hemodialysis', value: false },
            { title: 'Peritoneal dialysis', value: false },
        ],
    },
    {
        title: 'Cancer',
        values: [
            { title: 'Brain', value: false },
            { title: 'Head and neck (throat, larynx)', value: false },
            { title: 'Lungs', value: false },
            { title: 'Breast', value: false },
            { title: 'Stomach', value: false },
            { title: 'Pancreas', value: false },
            { title: 'Kidney', value: false },
            { title: 'Colon/Rectal', value: false },
            { title: 'Uterine/Ovarian', value: false },
            { title: 'Leukemia/Lymphoma', value: false },
        ],
    },
    {
        title: 'Metabolic/endocrine',
        values: [
            { title: 'Diabetes', value: false },
            { title: 'Thyroid disorder', value: false },
        ],
    },
    {
        title: 'Allergies',
        values: [
            {
                title: 'Allergies (Seasonal allergies, allergic rhinitis)',
                value: false,
            },
            { title: 'Rash/Eczema', value: false },
            { title: 'Anaphylaxis/Anaphylactic shock', value: false },
        ],
    },
    {
        title: 'Musculoskeletal/rheumatology',
        values: [
            { title: 'Back pain', value: false },
            { title: 'Fibromyalgia', value: false },
            { title: 'Carpel tunnel syndrome', value: false },
            { title: 'Osteoarthritis', value: false },
            { title: 'Rheumatoid arthritis', value: false },
            { title: 'Lupus (Systemic Lupus Erythematosus)', value: false },
            { title: 'Scleroderma', value: false },
        ],
    },
];
